(function () {
  'use strict';

  var config = {};
  try {
    var node = document.getElementById('ss-config');
    if (node) config = JSON.parse(node.textContent || '{}') || {};
  } catch (e) {
    config = {};
  }

  function openSignup() {
    var formId = config.formId ? String(config.formId).trim() : '';
    if (formId) {
      // The queue is read when Klaviyo onsite loads, so this works before the embed is ready.
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
      return;
    }
    if (config.fallbackUrl) {
      window.location.href = config.fallbackUrl;
      return;
    }
    if (window.console && console.warn) {
      console.warn('Spend & Save: no Klaviyo form ID or fallback link is set, run ss_switch.py on --form <id>.');
    }
  }

  function findTrigger(target) {
    while (target && target !== document) {
      if (target.nodeType === 1 && target.hasAttribute('data-ss-signup')) return target;
      target = target.parentNode;
    }
    return null;
  }

  // Capture phase so the card link and theme card handlers never see the click.
  document.addEventListener('click', function (event) {
    var trigger = findTrigger(event.target);
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openSignup();
  }, true);

  document.addEventListener('keydown', function (event) {
    var key = event.key || '';
    var code = event.keyCode;
    var isEnter = key === 'Enter' || code === 13;
    var isSpace = key === ' ' || key === 'Spacebar' || code === 32;
    if (!isEnter && !isSpace) return;
    var trigger = findTrigger(event.target);
    // Native buttons already turn Enter and Space into a click.
    if (!trigger || trigger.tagName === 'BUTTON') return;
    event.preventDefault();
    event.stopPropagation();
    openSignup();
  }, true);
})();
